import Swiper from "swiper";

document.addEventListener("DOMContentLoaded", () => {
  // var newcomerSwiper = new swiper('.js-swiper', {
  //   loop: true,
  //   slidesPerView: 2.25,
  //   speed: 1000,
  //   loopAdditionalSlides: 4,
  //   loopedSlides: 5,
  //   loopFillGroupWithBlank: true,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },
  //   breakpoints: {
  //     599: {
  //       slidesPerView: 1.5,
  //       // spaceBetween: 15,
  //     }
  //   }
  // });

  const swiper = new Swiper(".js-swiper", {
    loop: true,
    slidesPerView: 2.25,
    speed: 1000,
    loopAdditionalSlides: 4,
    loopedSlides: 5,
    loopFillGroupWithBlank: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      599: {
        slidesPerView: 1.5,
      },
    },
  });
});
